// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"infinite-scroller_loadingWrapper__yeCyl"};